import SharedShapeAdvancedConfig from "segments/desktop/shape/shared-shape-advanced-config.js";

export default {
  ...SharedShapeAdvancedConfig
};
